import { useQuery } from "@tanstack/react-query";
import {
  EmployeeConfigType,
  EmployeeRoleParams,
  EmployeeRoleService,
} from "../../../../../services/config/permission-config/employeeRole";
import { useSearchParams } from "../../../../../hook/use-search-params";
import { StringHelper } from "../../../../../helper";

export const useConfigEmployee = () => {
  const { searchParams } = useSearchParams();
  const roleId = searchParams.get("menuId") || "54";

  const { data = [], ...restResponse } = useQuery<EmployeeConfigType[]>({
    queryKey: ["config-employee", roleId],
    queryFn: () => EmployeeRoleService.getListByRoleId(+roleId!),
  });

  const createEmployeeRole = async (employee: EmployeeRoleParams) => {
    const res = await EmployeeRoleService.addEmployeeRole(employee);
    const result = { ...res, email: employee.email };
    return result;
  };

  const addEmployee = async (employees: string[], roleId: string) => {
    return await Promise.all(
      employees.map((e: string) => {
        return createEmployeeRole({
          email: StringHelper.verticalBarSplit(e)[0].toLowerCase(),
          description: StringHelper.verticalBarSplit(e)[1],
          note: "",
          roleId: +roleId,
        });
      }),
    );
  };

  return {
    data,
    addEmployee,
    ...restResponse,
  };
};
